import { PageRouteBuilder } from "@common/route/page-route-builder";
import { LoginPageComponent } from "./login-page.component";

export const loginPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-login-page", LoginPageComponent)
    .atUrl("/account/login")
    .requiresLogin(false)
    .requiresAnonymous(true)
    .build();
